import axios from '@axios'

export default {
  namespaced: true,
  state: {
    currentQuestion: null,
  },
  getters: {
    getCurrentQuestion: (state) => state.currentQuestion,
  },
  mutations: {
    SET_CURRENT_QUESTION(state, question) {
      state.currentQuestion = question;
    },
  },
  actions: {
    fetchSurveyQuestions(ctx, queryParams) {
      //console.log("survey questions Fetching");
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/questions/${queryParams.id}`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSurvey(ctx, { id }) {
      //console.log("single course  Fetching" );
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/surveydetail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatequestion(ctx, userData) {
      return new Promise((resolve, reject) => {
        var id = userData.id;
        axios
          .put(`/survey/admin/updatequestion/${id}`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCourse(ctx, { id }) {
      //console.log("single course  Fetching");
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/surveydetail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQuestion(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/question/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUnlinkedQuestions(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/unlinkedquestions/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    updateCourseInfo(ctx, { id }) {
      //console.log("update course  is launching with id : "+id);
      return;
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getcoursedetail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSurveyQuestion(ctx, userData) {

      //console.log("course Create triggered");
      //console.log(userData);


      return new Promise((resolve, reject) => {
        axios
          .post('/survey/admin/createquestion', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addSurvey(ctx, userData) {

      //console.log("course Create triggered");
      //console.log(userData);


      return new Promise((resolve, reject) => {
        axios
          .post('/survey/admin/survey', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    draftCourse(ctx, userData) {

      //console.log("draftCourse Create triggered");
      //console.log(userData);


      return new Promise((resolve, reject) => {
        axios
          .post('/lms/admin/course/draft', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    publishCourse(ctx, userData) {

      //console.log("publishCourse Create triggered");
      //console.log(userData);


      return new Promise((resolve, reject) => {
        axios
          .post('/survey/admin/surveypublish', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
